export const SALES_CHANNEL = 'sales_channel';
export const BRANCH_CODE = 'branch_code';
export const SOURCE_PARAM = 'source';
